export default () => ({
  junoPublicKey: process.env.VUE_APP_JUNO_PUBLIC_KEY || '085F6DB2B758C6C5EBF54156C6B3B7BC7D08C98881F45A9DD44CBDF6744EF5C9',
  junoCriptoLib: process.env.VUE_APP_JUNO_CRIPTO_LIB || 'https://sandbox.boletobancario.com/boletofacil/wro/direct-checkout.min.js',
  publicUrl: process.env.VUE_APP_PUBLIC_URL || 'http://localhost:8080',
  apiUrl: process.env.VUE_APP_API_URL || 'https://localhost:4000',
  institutionalUrl: process.env.VUE_APP_INSTITUTIONAL_URL || 'https://www.parcelex.com.br',
  storeUrl: process.env.VUE_APP_STORE_URL || 'http://localhost:4001',
  centraxUrl: process.env.VUE_APP_CENTRAX_URL || 'http://localhost:8081',
  onboardingUrl: process.env.VUE_APP_ONBOARDING_URL || 'http://localhost:5174',
  nodeEnv: process.env.VUE_APP_NODE_ENV || 'homolog',
  skeleton: {
    checkout: { timeout: 500 },
  },
  apiKey: '5f4934d7d0288300b73c4958',
  requestEncryptionKey: process.env.VUE_APP_REQUEST_ENCRYPTION_KEY || '1283c155a573668c84a8c4e214b476631d36761efa0edeb5a468c47a8b17f8cd',
  maxInstallments: 24,
  facetecDeviceKeyIdentifier: process.env.VUE_APP_DEVICE_KEY_IDENTIFIER || 'dioxhbQHfJHmnHTzJ40hCiUm3FR0IkXY',
  facetecProductionKeyTextDomains: process.env.VUE_APP_FACETEC_DOMAINS || '',
  facetecProductionKeyTextExpiryDate: process.env.VUE_APP_FACETEC_EXPIRY_DATE || '2025-02-10',
  facetecProductionKeyTextKey: process.env.VUE_APP_FACETEC_KEY || '003045022034af59be515053c5ea73ed493839325ce117fd6a763ebf600820dd1a9e56bc03022100ae7601ab735cce4b667ea57b9f5c5c285a3715264d2ccbfdc9754ad16105958f',
  captchaKey: process.env.VUE_APP_CAPTCHA_KEY || '6Le3lrglAAAAAG0azatTKPp6U1PbnWACQ9140S5K',
});
